import * as ScrollMagic from 'scrollmagic'; // Or use scrollmagic-with-ssr to avoid server rendering problems
import { ScrollMagicPluginIndicator} from 'scrollmagic-plugins';
ScrollMagicPluginIndicator(ScrollMagic);
import { TweenMax, TimelineMax, Linear } from 'gsap'; // Also works with TweenLite and TimelineLite
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap'; 
ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax, Linear); // There you can use setTween() in ScrollMagic Scene with no problems


export default {
  init() {
  // JavaScript to be fired on the about us page
  let controller = new ScrollMagic.Controller();

	// define movement of panels
	let wipeAnimation = new TimelineMax()
    .fromTo('#about-page__brand', 1, {y: '0%'}, {y: '0%', ease: Linear.easeNone,     onUpdate:function(){
      changeControls(this.targets()[0].id);
    }})
		.fromTo('#about-page__production', 1, {y: '100%'}, {y: '0%', ease: Linear.easeNone,     onUpdate:function(){
      changeControls(this.targets()[0].id);
    }})
		.fromTo('#about-page__control', 1, {y: '100%'}, {y: '0%', ease: Linear.easeNone,     onUpdate:function(){
      changeControls(this.targets()[0].id);
    }})
		.fromTo('#about-page__sertification', 1, {y: '100%'}, {y: '0%', ease: Linear.easeNone,     onUpdate:function(){
      changeControls(this.targets()[0].id);
    }})
		.fromTo('#about-page__responsibility', 1, {y: '100%'}, {y: '0%', ease: Linear.easeNone,     onUpdate:function(){
      changeControls(this.targets()[0].id);
    }});

	// create scene to pin and link animation
	new ScrollMagic.Scene({
		triggerElement: '#pinContainer',
		triggerHook: 'onLeave',
		duration: '300%',
	})
	.setPin('#pinContainer')
	.setTween(wipeAnimation)
	.addTo(controller)
  .on('start', function () {
    let id = 'about-page__brand';
    changeControls(id);
  });

  function changeControls(id) {
    let ancor = $('[about-page-menu-scroll] a[href$="' + id +'"]');
    if(!ancor.hasClass('active')) {
      $('[about-page-menu-scroll] a').removeClass('active');
      ancor.addClass('active');
    }
  }

  function sizeAll() {
    let	w = window.innerWidth;
    if ( w < 1024) {
      //blockScroll.enabled(false);
      controller.enabled(false);
    } else {
      //blockScroll.enabled(true);
      controller.enabled(true);
    }
  }

  $(window).resize(sizeAll);
  sizeAll();

	document.addEventListener('scroll', function() {
		let scrollTop     = $(window).scrollTop(),
		elementOffset = $('#about-page__production').offset().top,
		distance      = (elementOffset - scrollTop);
    let	w = window.innerWidth;

		if(distance <= 0 && w > 1024) {
			$('.header').addClass('hide');
			$('.breadcrumbs').addClass('hide');
		} else {
			$('.header').removeClass('hide');
			$('.breadcrumbs').removeClass('hide');
		}
	});

	let about_page_links = $('[about-page-menu-scroll] a');

	about_page_links.on('click', function(e) {
    let id = $($(this).attr('href'));
    
    $(id[0]).css('transform', 'translate(0px, 0%)');
    $(id[0]).nextAll().css('transform', 'translate(0px, 100%)');

    if($(this).attr('href') != '#about-page__brand') {
      $('.header').addClass('hide');
			$('.breadcrumbs').addClass('hide');
    } else {
			$('.header').removeClass('hide');
			$('.breadcrumbs').removeClass('hide');
		}

		if(!$(this).attr('target')) {
			e.preventDefault();
			if(!$(this).hasClass('active')) {
        about_page_links.removeClass('active');
        $(this).addClass('active');
			}
		}
	})

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/about.js